import { JOIN_SOURCES } from './organizationInvitations';

export const ORG_INVITE = JOIN_SOURCES.ORG_INVITE;
export const INVITE_LINK = JOIN_SOURCES.INVITE_LINK;
export const ANY = 'any';
